import GlobalStyles from "gamfi/assets/styles/GlobalStyles";
import Layout from "gamfi/components/layout";
import Header from "components/Header";
import { MetaverseProvider } from "blockchain/provider";
import { Outlet } from "react-router-dom";
import Banner from "components/Banner";
import About from "components/About";
import Footer from "components/Footer";
import MainBanner from "components/MainBanner";
// import Features from "gamfi/sections/Features/v1";
import ExploreProjects from "./ExploreProjects";
import FAQ from "./Faq";
import RoadMap from "./RoadMap";
import VideoCarousel from "./Carousel";
import { configureChains, createClient, goerli, WagmiConfig } from "wagmi";
import { EthereumClient, modalConnectors, walletConnectProvider } from "@web3modal/ethereum";
import { Web3Modal } from "@web3modal/react";
// import { StoryTeller } from "./History";

const projectId = "8a3eab2c7fe49a1ab52bb6accf43b483";

const chains = [goerli];

const { provider } = configureChains(chains, [walletConnectProvider({ projectId })]);

const wagmiClient = createClient({
  autoConnect: true,
  connectors: modalConnectors({ appName: "web3Modal", chains }),
  provider,
});

// Web3Modal Ethereum Client
const ethereumClient = new EthereumClient(wagmiClient, chains);

export const MetaverseLayout = () => (
  <MetaverseProvider>
    <WagmiConfig client={wagmiClient}>
      <Layout>
        <GlobalStyles />
        <Header />
        <Outlet />
        <Footer />
      </Layout>
    </WagmiConfig>

    <Web3Modal projectId={projectId} ethereumClient={ethereumClient} themeMode={`dark`} themeColor={`blue`} />
  </MetaverseProvider>
);

export const Home = () => {
  return (
    <>
      <MainBanner />
      <ExploreProjects />
      {/* <Features /> */}
      <FAQ />
      <RoadMap />
    </>
  );
};

export const History = () => {
  return (
    <>
      <VideoCarousel />
      {/* <StoryTeller /> */}
    </>
  );
};

export const Airdrop = () => {
  return (
    <>
      <Banner />
      <About />
    </>
  );
};
